import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Approval, PaginatedApprovalResponse, ApprovalUserInput } from '../models/approval';
import { environment } from '../../environments/environment';
import { PaginatedRequest } from '../models/paginated-request';

@Injectable()
export class ApprovalService {

  baseUrl = environment.approvalServiceBaseUrl;

  constructor(private http: HttpClient) { }

  getAllApprovals(approvaluserInput: ApprovalUserInput, paginatedRequest: PaginatedRequest) {
    const url = `${this.baseUrl}approvals/details`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const params = new HttpParams()
      .set('page', paginatedRequest.page)
      .set('size', paginatedRequest.pageSize)
      .set('sort', paginatedRequest.sorting);
    return this.http.post<PaginatedApprovalResponse>(url, approvaluserInput, { params, headers });
  }

  getAllPendingApprovals(paginatedRequest: PaginatedRequest) {
    const url = `${this.baseUrl}approvals/getAllPending`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    const params = new HttpParams()
      .set('page', paginatedRequest.page)
      .set('size', paginatedRequest.pageSize)
      .set('sort', paginatedRequest.sorting);
    return this.http.get<PaginatedApprovalResponse>(url, { params, headers });
  }

  getApproval(id: string) {
    const url = `${this.baseUrl}approvals/${id}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<Approval>(url, { headers });
  }

  approve(id: string, reason?: string) {
    const url = `${this.baseUrl}approve/${id}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.put<void>(url, reason, { headers });
  }

  approveV2(id: string, reason?: string) {
    const url = `${this.baseUrl}v2/approve/${id}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.put<void>(url, reason, { headers });
  }

  deny(id: string, reason?: string) {
    const url = `${this.baseUrl}deny/${id}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.put<void>(url, reason, { headers });
  }

  getPendingApprovalsByUser(userId: string) {
    const url = `${this.baseUrl}pendingapprovalsbyuser/${userId}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<Approval[]>(url, { headers });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/approval.service.ts